const InputTextField = ({
  handleInputChange,
  onKeydown,
  valueText,
  inputName,
  fieldName,
  inputId,
  inputType,
  classname,
  minLen,
  maxLen,
  disabled,
  placeholderValue,
  mindate,
  maxdate,
  autoComplete = "off"
}) => {
  return (
    <input
      type={inputType}
      name={inputName || fieldName}
      id={inputId}
      autoComplete={autoComplete || "off"}
      onKeyDown={onKeydown}
      className={classname}
      value={valueText}
      onChange={handleInputChange}
      onContextMenu={(e) => e.preventDefault()}
      minLength={minLen}
      maxLength={maxLen}
      disabled={disabled}
      placeholder={placeholderValue}
      min={mindate}
      max={maxdate}
      onKeyPress={
        /* istanbul ignore next -- React 18 + jsdom does not deliver 'keypress' to synthetic handlers */
        (e) => {
          e.key === 'Enter' && e.preventDefault()
        }
      }
    />
  )
}

export default InputTextField
